var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultPageLayout',{attrs:{"headerStyle":{
  'padding-top': '60px',
  'padding-bottom': '35px',
}}},[_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"fs-20 fs-md-24 font-weight-bold white--text"},[_vm._v(" "+_vm._s(_vm.$t('estimate.getEstimateTitle'))+" ")]),_c('p',{staticClass:"fs-16 font-weight-regular white--text"},[_vm._v(" "+_vm._s(_vm.$t('estimate.getEstimateSubtitle'))+" ")])]),_c('router-view',{staticClass:"estimate-router-view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }